module.exports = __webpack_public_path__ + "media/images/games/clash-royale/square-bf26b18e777b5295a2779be1c1647844.jpg";